/* LivoNest — footer newsletter
   Shopify protects contact/customer forms with hCaptcha: the token is produced
   by Shopify's own script and written into `h-captcha-response` on submit.
   An AJAX submit bypasses that handshake (the server answers "Missing CAPTCHA
   token"), so the form submits natively and we only add the thank-you state. */

(function () {
  const form = document.querySelector('.lnf__form');
  if (!form || form.dataset.lnfBound) return;
  form.dataset.lnfBound = '1';

  // make sure the platform wires this form even if it rendered after boot
  if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
    try {
      window.Shopify.captcha.protect(form);
    } catch (error) {
      /* non-fatal: the platform already wires matching forms on load */
    }
  }

  // when Shopify redirects back with ?customer_posted=true, surface it next to
  // the field instead of leaving the shopper to find the contact page message
  const params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true' && document.getElementById('footer-newsletter')) {
    const message = document.createElement('p');
    message.className = 'lnf__message lnf__message--ok';
    message.textContent = 'Thank you — please check your inbox to confirm.';
    form.appendChild(message);
    message.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
})();
